import React, { useState } from "react";
import { Navbar, Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { FaLinkedin } from "react-icons/fa";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Header.css";

const Header = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      {/* Header content */}
      <Navbar expand="lg" className="navbar-container">
        <Container>
          {/* Logo */}
          <Navbar.Brand href="/">
            <img
              src="/assets/asyncVibeLogo.png"
              alt="asyncVibe Logo"
              className="navbar-logo"
            />
          </Navbar.Brand>

          {/* Mobile Toggle Button */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {/* Services Dropdown */}
              <NavDropdown
                title="Services"
                id="services-dropdown"
                onMouseEnter={() => setShowDropdown("services")}
                onMouseLeave={() => setShowDropdown(null)}
                show={showDropdown === "services"}
                className="navbar-dropdown"
              >
                <div className="custom-dropdown-menu">
                  <div className="dropdown-image">
                    <img src="/assets/dropDownImage.avif" alt="Services" />
                  </div>
                  <div className="dropdown-links">
                    <div className="dropdown-section">
                      <h6>Development</h6>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Web Application <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Mobile Application <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/serviceDetails')}>AI Application <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Block Chain <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/serviceDetails')}>Custom Application <FaArrowUpRightFromSquare /></button>
                    </div>
                    <div className="dropdown-section">
                      <h6>Solutions</h6>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/')}>Virtual Team <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/')}>API Integrations <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/')}>Maintenance & Support <FaArrowUpRightFromSquare /></button>
                    </div>
                  </div>
                </div>
              </NavDropdown>

              {/* About Us Dropdown */}
              <NavDropdown
                title="About Us"
                id="about-dropdown"
                onMouseEnter={() => setShowDropdown("about")}
                onMouseLeave={() => setShowDropdown(null)}
                show={showDropdown === "about"}
                className="navbar-dropdown"
              >
                <div className="custom-dropdown-menu">
                  <div className="dropdown-image">
                    <img src="/assets/dropDownImage.avif" alt="About Us" />
                  </div>
                  <div className="dropdown-links">
                    <div className="dropdown-section">
                      <h6>About Us</h6>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/aboutUs')}>Company <FaArrowUpRightFromSquare /></button>
                      <button className="dropdown-link-btn" onClick={() => handleNavigation('/ourGlobalImpact')}>Our Global Impact <FaArrowUpRightFromSquare /></button>
                    </div>
                  </div>
                </div>
              </NavDropdown>
              <button className="nav-link-btn" onClick={() => handleNavigation('/contactUs')}>Contact Us</button>
              <button className="nav-link-btn" onClick={() => handleNavigation('/blogs')}>Blogs</button>
              <button className="nav-link-btn" onClick={() => handleNavigation('/portfolio')}>Portfolio</button>
              <button className="nav-link-btn" onClick={() => handleNavigation('/roles')}>Roles</button>
              <button className="nav-link-btn" onClick={() => handleNavigation('/cloudMembership')}>Memberships</button>

              {/* Contact Button */}
              <Button
                href=""
                target="_blank"
                className="ms-3 px-4 py-2 text-white d-flex align-items-center header-button-linkdin"
                style={{
                  backgroundColor: '#221A28',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '500',
                  letterSpacing: '0.5px',
                  transition: 'all 0.3s ease'
                }}
              >
                Follow Us
                <FaLinkedin
                  size={20}
                  className="ms-2 linkedin-icon"
                  style={{
                    color: 'white',
                  }}
                />
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;